module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-down-+.da741930.svg";